














































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';

import type { Worksheet } from '@/models/worksheet';
import type { AppliedLesson } from '@/models/appliedlesson';
import type { Company } from '@/models/company';
import { AppliedLessonType } from '@/enums/AppliedLessonType';
import { goToNativeLink } from '@/helpers/routing/links';

@Component({
    name: 'PrintSingleWorksheet',
    components: {},
})
export default class PrintSingleWorksheet extends Vue {
    @Prop() private tableColumns;
    @Prop() private worksheet: Worksheet;
    @Prop() private appliedLessons: AppliedLesson[];
    @Prop() private onlyPR: boolean;
    @Prop() private showResolved: boolean;
    @Prop() private type: AppliedLessonType;

    @Getter('account/company') private company: Company;

    // noinspection JSUnusedGlobalSymbols
    get sortedAppliedLessons() {
        let nonProjectOnlyLessons = this.appliedLessons.filter((el) => !el.lesson.project_only);
        const projectOnlyLessons = this.appliedLessons.filter((el) => el.lesson.project_only);

        nonProjectOnlyLessons = nonProjectOnlyLessons.sort((a, b) => {
            const ia = a.lesson.insight;
            const ib = b.lesson.insight;
            if (ia < ib) {
                return -1;
            }
            if (ia > ib) {
                return 1;
            }
            return 0;
        });

        return nonProjectOnlyLessons.concat(projectOnlyLessons);
    }

    private printWorksheetNew() {
        const worksheetId = this.worksheet.id;
        const fields = Object.keys(this.tableColumns)
            .filter((key) => this.tableColumns[key].display)
            .map((key) => {
                const columnFields = [key.toLowerCase()];
                if (this.tableColumns[key] && this.tableColumns[key].additionalFields) {
                    columnFields.push(...this.tableColumns[key].additionalFields.map((f) => f.toLowerCase()));
                }
                return columnFields;
            })
            .flat();

        const fieldsString = fields.join(',');

        const onlyPR = this.onlyPR;
        const type =
            this.type === AppliedLessonType.PMAppliedLesson
                ? 'pm'
                : this.type === AppliedLessonType.XAppliedLesson
                ? 'x'
                : '';
        const showResolved = this.showResolved;

        const params = [
            `worksheetId=${worksheetId}`,
            `type=${type}`,
            `showResolved=${showResolved}`,
            `fields=${fieldsString}`,
            `onlyPR=${onlyPR}`,
            `projectId=${this.worksheet.project.id}`,
        ];

        goToNativeLink(`/convert/worksheet-applied-lessons?${params.join('&')}`, true);
    }
}
